import Vue from "vue";
import _ from "lodash";

import { date } from "@/components/mixins/date";
import { factoryMachinesApi } from "@/api/factoryMachinesApi";
import { getMachineStatusDay } from "@/stores/helpers/machinesHelper";
import {
  mapDataToStandardTimelineData,
  insertPointInData,
  timelineFiltered
} from "@/stores/helpers/statusTimelineHelper";

export default {
  state: {
    timelines: {}
  },
  getters: {
    getTimelineById: state => id => {
      return state.timelines[id];
    },
    getTimelineByMachine: (state, getters) => machine => {
      const id = machine && machine.Id;
      return getters.getTimelineById(id);
    },
    getAlarmsTimelineByMachine: (state, getters) => machine => {
      const id = machine && machine.Id;
      const timeline = getters.getTimelineById(id);
      let result = undefined;

      if (timeline) {
        result = timelineFiltered(
          timeline,
          "fail",
          date.methods.objDateTodayStartOf("day").toISOString()
        );
      }

      return result;
    }
  },
  actions: {
    async fetchTimelineByMachine({ commit, state }, machine) {
      const id = machine && machine.Id;

      if (_.isEmpty(state.timelines[id])) {
        let result = undefined;
        let timeline = undefined;
        let raw = machine.status.raw;

        if (!raw) {
          try {
            const status = await factoryMachinesApi.getSingleStatus(machine.Id);
            raw = status.raw;
          } catch (e) {
            console.error("[Error] Fetch status by machine failed.", e);
          }
        }

        try {
          result = await getMachineStatusDay(machine);
        } catch (e) {
          console.error("[Error] Fetch timeline by machine failed.", e);
        }

        try {
          timeline = await mapDataToStandardTimelineData(result, raw);
        } catch (e) {
          console.error("[Error] Map data to timeline by machine failed.", e);
        }

        commit("SET_TIMELINE_BY_MACHINE", { timeline, machineId: id });
      }
    }
  },
  mutations: {
    STREAM_MachineStatusChanged(state, payload) {
      const { machineId, data } = payload;

      if (machineId) {
        const timeline = state.timelines[machineId];

        if (!_.isEmpty(timeline)) {
          const result = insertPointInData(data, timeline);

          Vue.set(state.timelines, machineId, result);
        }
      }
    },
    INIT_TIMELINE_BY_MACHINE: (state, { machine }) => {
      const id = machine && machine.Id;

      if (id) {
        Vue.set(state.timelines, id, {});
      }
    },
    SET_TIMELINE_BY_MACHINE: (state, { timeline, machineId }) => {
      if (machineId) {
        Vue.set(state.timelines, machineId, timeline);
      }
    }
  },
  namespaced: true,
  modules: {}
};
